/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdstudemployee_Goethe20Inputs */

const en__field_enum_sdstudemployee_goethe20 = /** @type {(inputs: _Field_Enum_Sdstudemployee_Goethe20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stud. Mitarb. der Goethe-Universität`)
};

const de__field_enum_sdstudemployee_goethe20 = /** @type {(inputs: _Field_Enum_Sdstudemployee_Goethe20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stud. Mitarb. der Goethe-Universität`)
};

/**
* | output |
* | --- |
* | "Stud. Mitarb. der Goethe-Universität" |
*
* @param {_Field_Enum_Sdstudemployee_Goethe20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdstudemployee_goethe20 = /** @type {((inputs?: _Field_Enum_Sdstudemployee_Goethe20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdstudemployee_Goethe20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdstudemployee_goethe20(inputs)
	return de__field_enum_sdstudemployee_goethe20(inputs)
});
export { _field_enum_sdstudemployee_goethe20 as "_field_enum_SDSTUDEMPLOYEE_GOETHE" }